import React from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { Headphones, Heart, Users, BookOpen, Music2, ArrowRight, Check } from 'lucide-react';
import { FinalCta } from './ForArtists';

const PERKS = [
  { Icon: Headphones, color: '#22d3ee', title: 'TikTok-style music reel', desc: 'Swipe through indie artists. Like, follow, share — fuel the ones you love.' },
  { Icon: Heart,      color: '#ff6b8a', title: 'Liked tracks + watch later', desc: 'Build a personal collection that follows you across devices.' },
  { Icon: Users,      color: '#a78bfa', title: 'Follow + support artists', desc: 'Direct line to working musicians. Their drops show up at the top of your reel.' },
  { Icon: BookOpen,   color: '#34d399', title: 'Free music-business podcasts', desc: "Curious how artists actually get paid? Listen to working musicians break it down — free in our Knowledge Hub." },
];

export default function ForListeners() {
  const { user } = useApp();
  const cta = user ? '/feed' : '/signup/listener';
  const ctaLabel = user ? 'Open the reel' : 'Join free as a listener';
  return (
    <div className="max-w-[1100px] mx-auto" data-testid="landing-listeners">
      <header className="py-10 md:py-16">
        <div className="chip"><Music2 className="w-3 h-3" /> For listeners</div>
        <h1 className="font-display text-[40px] sm:text-[56px] md:text-[72px] leading-[0.95] mt-4 max-w-[960px]">
          Discover indie music. <span className="text-[#22d3ee]">Learn how it works.</span>
        </h1>
        <p className="text-white/70 text-[16px] md:text-[18px] mt-5 max-w-[680px] leading-relaxed">
          A music reel built around your follows, not algorithmic mystery. Plus the rare bonus: free education on how the music business actually works. Free, forever.
        </p>
      </header>

      <section className="grid sm:grid-cols-2 gap-3 mb-7">
        {PERKS.map(p => (
          <div key={p.title} className="card-shell p-5 hover-lift">
            <div className="w-10 h-10 rounded-xl grid place-items-center" style={{ background: p.color + '22', color: p.color }}><p.Icon className="w-5 h-5" /></div>
            <h3 className="font-display text-[16px] mt-3">{p.title}</h3>
            <p className="text-[12.5px] text-white/60 mt-1.5 leading-relaxed">{p.desc}</p>
          </div>
        ))}
      </section>

      <FinalCta href={cta} label={ctaLabel} />
    </div>
  );
}
